import config from '../../config/runtime_config.js'

const USER = {
	install (Vue, options) {
		Vue.prototype.$user = {

			isAdmin () {
				let user = options.store.getters.user
				if (!user) return false
				if (!user.hasOwnProperty('email')) return false
				if (!user.email) return false
				return config._$a4ae4h.indexOf(user.email.toLowerCase()) > -1
			},

			isSupportAdmin () {
				let user = options.store.getters.user
				if (!user) return false
				if (!user.hasOwnProperty('email')) return false
				if (!user.email) return false
				return config._$a4ae4h.indexOf(user.email.toLowerCase()) > -1 ||
					config._$oetoyl.indexOf(user.email.toLowerCase()) > -1
			},

			platform () {
				return navigator.platform
			},

			email_as_user (email) {
				let emailArr = email.split('@')
				return emailArr[0].split('.').join(' ')
			}

		}
	}
}

export default USER



// WEBPACK FOOTER //
// ./src/plugins/user.js